import { queryKeys } from '@/constant/common'
import { DeleteType } from '@/types/hydraulic'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { toast } from 'react-hot-toast'
import { NotifyService } from '@/helpers'
import { useConfigUI } from '../../context'
import turfQualityApi from '@/api/config/turfQualityApi'
import useTranslation from '@/hooks/useTranslation'

async function deleteTurfQuality(
  interfaceId: string,
  id: string,
): Promise<void> {
  await turfQualityApi.delete({ interfaceId, id })
}
const useDeleteTurfQuality = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeModal } = useConfigUI()

  return useMutation(
    (payload: DeleteType) => deleteTurfQuality(payload.interfaceId, payload.id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.turfQuality])
        toast.success(t('DeletePipeSuccess'))
        closeModal()
      },
      onError: (error: AxiosError<any>) => {
        NotifyService.error(error)
        closeModal()
      },
    },
  )
}

export default useDeleteTurfQuality
